import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Space, Typography, message, Tag, Empty } from 'antd';
import { ReloadOutlined, CarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { invoiceService, shippingService } from '../../services';

const { Title, Text } = Typography;

const ShippingList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [creatingOrder, setCreatingOrder] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await invoiceService.export.getShippingList();
      if (response.success) {
        setData(response.data || []);
        message.success(`Tải thành công ${response.count || 0} hóa đơn`);
      } else {
        message.error(response.message || 'Không thể tải dữ liệu');
      }
    } catch (error) {
      message.error('Lỗi khi tải dữ liệu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateOrder = async (orderCode) => {
    setCreatingOrder(orderCode);
    try {
      const response = await shippingService.createOrder(orderCode);
      if (response.success) {
        console.log('Create order response:', response);
        console.log('Print link:', response.data.print_link);
        message.success(`Tạo vận đơn thành công: ${response.data.ORDER_NUMBER}. Đang in...`, 3);
        if (response.data.print_link) {
          // Kiểm tra nếu đang chạy trong Electron
          if (window.require) {
            try {
              const { ipcRenderer } = window.require('electron');
              ipcRenderer.send('print-url', response.data.print_link);
              message.success('Gửi lệnh in tự động!');
            } catch (e) {
              console.log('Lỗi Electron IPC:', e);
              window.open(response.data.print_link, '_blank');
            }
          } else {
            // Chạy trong browser thường
            const printWindow = window.open(response.data.print_link, '_blank');
            if (printWindow) {
              setTimeout(() => {
                try {
                  printWindow.print();
                  setTimeout(() => {
                    try {
                      printWindow.close();
                    } catch (e) {
                      console.log('Không thể đóng tab tự động');
                    }
                  }, 2000);
                } catch (e) {
                  console.log('Không thể in tự động do cross-origin:', e);
                  message.warning('Vui lòng bấm Ctrl+P để in trên trang đã mở');
                }
              }, 3000);
            } else {
              message.error('Vui lòng cho phép popup để mở trang in');
            }
          }
        }
        loadData();
      } else {
        message.error(response.message || 'Tạo vận đơn thất bại');
      }
    } catch (error) {
      message.error('Lỗi: ' + error.message);
    } finally {
      setCreatingOrder(null);
    }
  };

  const columns = [
    {
      title: 'STT',
      key: 'index',
      width: 60,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Mã hóa đơn',
      dataIndex: 'CODE',
      key: 'CODE',
      render: (text) => <Text strong copyable>{text}</Text>
    },
    {
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => (
        <Space>
          <ClockCircleOutlined />
          {dayjs(date).format('DD/MM/YYYY HH:mm')}
        </Space>
      )
    },
    {
      title: 'Trạng thái',
      key: 'status',
      render: () => <Tag color="green">Đã duyệt</Tag>
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button 
            type="primary" 
            icon={<CarOutlined />} 
            size="small"
            loading={creatingOrder === record.CODE}
            onClick={() => handleCreateOrder(record.CODE)}
          >
            Tạo vận đơn
          </Button>
          <Button 
            size="small"
            onClick={() => {
              console.log('Order Code:', record.CODE);
              message.info(`Mã đơn: ${record.CODE}`);
            }}
          >
            Kiểm tra
          </Button>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Title level={3}>
                <CarOutlined style={{ marginRight: 8 }} />
                Danh sách hóa đơn cần tạo vận đơn
              </Title>
              <Text type="secondary">
                Tối đa 10 hóa đơn đã duyệt, sắp xếp theo thời gian tạo
              </Text>
            </div>
            <Button icon={<ReloadOutlined />} onClick={loadData} loading={loading}>
              Làm mới
            </Button>
          </div>
        </div>

        {data.length > 0 ? (
          <Table
            columns={columns}
            dataSource={data}
            rowKey="CODE"
            loading={loading}
            pagination={false}
          />
        ) : (
          <Empty description="Không có hóa đơn nào cần tạo vận đơn" />
        )}
      </Card>
    </div>
  );
};

export default ShippingList;
